// extracted by mini-css-extract-plugin
export var aircallIframe = "_dm-3";
export var fabContainer = "_dm-5";
export var fabRinging = "_dm-6";
export var loadingOverlay = "_dm-4";
export var pulse = "_dm-7";
export var widgetContent = "_dm-2";
export var widgetPanel = "_dm-0";
export var widgetPanelExpanded = "_dm-1";